export function colorFormulation() {
    let $hero = $('.hero-color-formulation');
    let $steps = $('.steps-color-formulation');
    let productList = $steps.find(".product-list");
    const form = $steps.find(".send-products-result");

    $(window).on("load", function () {
        let header = $('.header').innerHeight() + ($('.header-banner').length ? $('.header-banner').innerHeight() : 0);

        $hero.css('min-height', 'calc(100vh - ' + header + 'px)');
        $steps.css('min-height', 'calc(100vh - ' + header + 'px)');
    });

    $(document).on('click', '.start', function (e) {
        e.preventDefault();

        $hero.toggleClass('hide');
        $steps.toggleClass('show').find('.step-color-formulation').removeClass('show').find('.list--items li').removeClass('active');

        $steps.find('.step-color-formulation:first-child').addClass('show');

        productList.find(".slider").slick('setPosition');

        $('html,body').animate({scrollTop: 0}, 500);
    });

    $(".step-color-formulation").each(function () {
        let $step = $(this);

        $step.on("click", ".list--items li", function () {
            let $this = $(this);

            $this.toggleClass('active').siblings().removeClass('active');

            if ($this.hasClass('active')) {
                $step.find('.next').removeClass('isDisabled');
            } else {
                $step.find('.next').addClass('isDisabled');
            }
        });

        $step.on("click", ".tonal-categories .list--items li", function () {
            let $this = $(this);
            let category = $this.attr('data-category');

            $step.find('.next').addClass('isDisabled');
            $('.tonal-items li').removeClass('active');

            if ($this.hasClass('active')) {
                $('.tonal-items').removeClass('hide').find('li').each(function () {
                    let $this = $(this);

                    if ($.inArray(category, JSON.parse($this.attr('data-category'))) !== -1) {
                        $this.removeClass('hide');
                    } else {
                        $this.addClass('hide');
                    }
                });
            } else {
                $('.tonal-items, .tonal-items li').addClass('hide');
            }
        });

        $step.on('click', '.next, .skip', function (e) {
            e.preventDefault();
            let $this = $(this);

            if ($step.hasClass('brands')) {
                let data = {
                    'action': 'get_hair_application',
                    'brand': $step.find(".list--items li.active").attr('data-term')
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $this.addClass('isDisabled');
                    },
                    success: function (response) {
                        $steps.find('.hair-application .ajax-holder-list').html(response);
                    },
                    complete: function () {
                        $this.removeClass('isDisabled');

                        $step.removeClass('show').next().addClass('show');
                        $('html,body').animate({scrollTop: 0}, 500);
                    }
                });

            }

            if ($step.hasClass('hair-application')) {
                let data = {
                    'action': 'get_natural_hair_depth',
                    'brand': $steps.find(".brands .list--items li.active").attr('data-term'),
                    'hair-app': $step.find(".list--items li.active").attr('data-term')
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $this.addClass('isDisabled');
                    },
                    success: function (response) {
                        $steps.find('.natural-hair-depth .ajax-holder-list').html(response);
                    },
                    complete: function () {
                        $this.removeClass('isDisabled');

                        $step.removeClass('show').next().addClass('show');
                        $('html,body').animate({scrollTop: 0}, 500);
                    }
                });
            }

            if ($step.hasClass('natural-hair-depth')) {
                let data = {
                    'action': 'get_percent_white_hair',
                    'brand': $steps.find(".brands .list--items li.active").attr('data-term'),
                    'hair-app': $steps.find(".hair-application .list--items li.active").attr('data-term'),
                    'natural-hair': $step.find(".list--items li.active").attr('data-term')
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $this.addClass('isDisabled');
                    },
                    success: function (response) {
                        $steps.find('.percent-white-hair .ajax-holder-list').html(response);
                    },
                    complete: function () {
                        $this.removeClass('isDisabled');

                        $step.removeClass('show').next().addClass('show');
                        $('html,body').animate({scrollTop: 0}, 500);
                    }
                });
            }

            if ($step.hasClass('percent-white-hair')) {
                let data = {
                    'action': 'get_desired_hair_depth',
                    'brand': $steps.find(".brands .list--items li.active").attr('data-term'),
                    'hair-app': $steps.find(".hair-application .list--items li.active").attr('data-term'),
                    'natural-hair': $steps.find(".natural-hair-depth .list--items li.active").attr('data-term'),
                    'percent': $step.find(".list--items li.active").attr('data-term')
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $this.addClass('isDisabled');
                    },
                    success: function (response) {
                        $steps.find('.desired-hair-depth .ajax-holder-list').html(response);
                    },
                    complete: function () {
                        $this.removeClass('isDisabled');

                        $step.removeClass('show').next().addClass('show');
                        $('html,body').animate({scrollTop: 0}, 500);
                    }
                });
            }

            if ($step.hasClass('desired-hair-depth')) {
                let data = {
                    'action': 'get_tonal_directions',
                    'brand': $steps.find(".brands .list--items li.active").attr('data-term'),
                    'hair-app': $steps.find(".hair-application .list--items li.active").attr('data-term'),
                    'natural-hair': $steps.find(".natural-hair-depth .list--items li.active").attr('data-term'),
                    'percent': $steps.find(".percent-white-hair .list--items li.active").attr('data-term'),
                    'desired-hair': $step.find(".list--items li.active").attr('data-term')
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $this.addClass('isDisabled');
                    },
                    success: function (response) {
                        $steps.find('.tonal .ajax-holder-list').html(response);
                    },
                    complete: function () {
                        $this.removeClass('isDisabled');

                        $step.removeClass('show').next().addClass('show');
                        $('html,body').animate({scrollTop: 0}, 500);
                    }
                });
            }

            if ($step.hasClass('tonal')) {
                let data = {
                    'action': 'get_result',
                    'brand': $steps.find(".brands .list--items li.active").attr('data-term'),
                    'hair-app': $steps.find(".hair-application .list--items li.active").attr('data-term'),
                    'natural-hair': $steps.find(".natural-hair-depth .list--items li.active").attr('data-term'),
                    'percent': $steps.find(".percent-white-hair .list--items li.active").attr('data-term'),
                    'desired-hair': $steps.find(".desired-hair-depth .list--items li.active").attr('data-term'),
                    'tonal': $step.find(".tonal-items .list--items li.active").attr('data-term')
                };

                $.ajax({
                    url: ajax_params.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $this.addClass('isDisabled');
                    },
                    success: function (response) {
                        $steps.find('.result .ajax-holder-list').html(response.result);

                        if (response.post_id) {
                            form.find("input[name='result']").val(response.post_id);
                        }

                        if (response.products) {
                            $steps.find('.get-products .ajax-holder-products').html(response.products);
                        }
                    },
                    complete: function () {
                        $this.removeClass('isDisabled');

                        $step.removeClass('show').next().addClass('show');
                        $('html,body').animate({scrollTop: 0}, 500);
                    }
                });
            }

            if ($step.hasClass('result')) {
                let $this = $(this);

                if ($this.hasClass('get-products')) {
                    let data = {
                        'action': 'send_result',
                        'data': form.serializeArray()
                    };

                    $.ajax({
                        url: ajax_params.ajaxurl,
                        data: data,
                        type: 'POST',
                        beforeSend: function () {
                            $this.addClass('isDisabled');
                        },
                        success: function (response) {
                            if (response.status === true) {
                                $step.removeClass('show');
                                $steps.find('.get-products').addClass('show');

                                // setTimeout(function () {
                                //     productList.find(".slider").slick('setPosition');
                                // }, 500);

                                $('html,body').animate({scrollTop: 0}, 500);
                            }
                        },
                        complete: function () {
                            $this.removeClass('isDisabled');
                        }
                    });

                } else {
                    $step.removeClass('show').next().addClass('show');
                    $('html,body').animate({scrollTop: 0}, 500);
                }
            }

            if ($step.hasClass('send-result')) {
                $step.removeClass('show').next().addClass('show');
                $('html,body').animate({scrollTop: 0}, 500);
            }
        });

        $step.on('click', '.back', function (e) {
            e.preventDefault();

            $step.removeClass('show').prev().addClass('show');
            $('html,body').animate({scrollTop: 0}, 500);
        });
    });

    const pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    form.on('input change', '.input-text', function () {
        let $parent = $(this).closest('.form-row');

        if (!pattern.test($(this).val())) {
            $parent.addClass('woocommerce-invalid');
            form.find('.button').addClass('isDisabled');
        } else {
            $parent.removeClass('woocommerce-invalid');
            form.find('.button').removeClass('isDisabled');
        }
    });

    form.submit(function (e) {
        e.preventDefault();

        let $this = $(this),
            data = {
                'action': 'send_result',
                'data': $this.serializeArray()
            };

        $.ajax({
            url: ajax_params.ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function () {
                $this.find('.button').addClass('isDisabled');
            },
            success: function (response) {
                if (response.status === false) {
                    $this.find('.response-error').text(response.message);

                } else {
                    $this.find('.response-error').text('');

                    $steps.find('.step-color-formulation').removeClass('show');
                    $steps.find('.get-products').addClass('show');

                    // setTimeout(function () {
                    //     productList.find(".slider").slick('setPosition');
                    // }, 500);

                    $('html,body').animate({scrollTop: 0}, 500);
                }
            },
            complete: function () {
                $this.find('.button').removeClass('isDisabled');
            }
        });

        return false;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/color-formulation.js